module.exports = __webpack_public_path__ + "static/media/inspection-type-report.342c79a7.svg";